import { useTranslation } from 'next-i18next'

import subscriptionAnalytics from '~/analytics/subscription/subscriptionAnalytics'
import appConfig from '~/config/app'
import { Link } from '~/components'

import ROUTES from '~/shared/constants/routes.const'

import ResponsiveImage from './Image/ResponsiveImage'

export default function UpgradeBanner(): React.ReactElement | null {
  const { t } = useTranslation('generics')

  // /get-started/price 404s in the school platform, where every seat is premium anyway.
  if (appConfig.isSchoolPlatform) return null

  const handleClickOnSubscribeButton = (): void => {
    subscriptionAnalytics.logButtonClick('upgrade_banner_subscribe_button')
    subscriptionAnalytics.logCtaClick('upgrade_banner_subscribe_button')
  }

  return (
    <section className="flex bg-gradient-orange-to-violet rounded-4 h-14 w-full md:w-4/5 lg:w-122 2xl:w-147 border border-white shadow-light mt-3">
      <ResponsiveImage className="px-3 py-1.5" height={40} srcKey="dashboard/gift-box.svg" width={40} />
      <Link
        className="w-4/5 md:w-9/10 flex items-center justify-center font-bold tracking-wider text-5 text-white"
        onClick={handleClickOnSubscribeButton}
        to={ROUTES.GET_STARTED_PRICE}
      >
        {t('upgradeToPremium')}
      </Link>
    </section>
  )
}
